import { render, staticRenderFns } from "./FormPlace.vue?vue&type=template&id=78781720&"
import script from "./FormPlace.vue?vue&type=script&lang=js&"
export * from "./FormPlace.vue?vue&type=script&lang=js&"
import style0 from "./FormPlace.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports